import moment from 'moment'

import {
  addWorksheet,
  createWorkbook,
  currencyFormat,
  DEFAULTNUMHEADERS,
  excelHeaderStyle,
  saveWorkbook,
  setHeaders,
  styleTotalRow,
} from '../../utilities/helpers'

const monthLabel = (monthKey) => moment(`${monthKey}-01`).format('MMM YYYY')

const money = (value) => Number(value || 0)

export const exportAccountingReportExcel = ({
  report,
  organizationName,
  fromDate,
  toDate,
}) => {
  if (!report?.teams?.length) return

  const workbook = createWorkbook()
  const worksheet = addWorksheet('Accounting', workbook)
  const rangeLabel = `Date range: ${moment(fromDate).format(
    'MMM D, YYYY'
  )} – ${moment(toDate).format('MMM D, YYYY')}`

  setHeaders('Accounting', organizationName, worksheet, [
    rangeLabel,
    'Card service fees are collected. Non-card service fees are owed. Complimentary orders are not charged a service fee.',
  ])

  const months = report.months || []
  const groupHeaderRowNumber =
    (worksheet.lastRow?.number || DEFAULTNUMHEADERS) + 1
  const columnHeaderRowNumber = groupHeaderRowNumber + 1
  const headerRows = columnHeaderRowNumber
  const groupHeaderRow = worksheet.getRow(groupHeaderRowNumber)
  const columnHeaderRow = worksheet.getRow(columnHeaderRowNumber)

  groupHeaderRow.getCell(1).value = 'Team'

  months.forEach((monthKey, index) => {
    const startCol = 2 + index * 2
    groupHeaderRow.getCell(startCol).value = monthLabel(monthKey)
    groupHeaderRow.getCell(startCol + 1).value = ''
    columnHeaderRow.getCell(startCol).value = 'Collected'
    columnHeaderRow.getCell(startCol + 1).value = 'Owed'
    worksheet.mergeCells(
      groupHeaderRowNumber,
      startCol,
      groupHeaderRowNumber,
      startCol + 1
    )
  })

  const totalsStart = 2 + months.length * 2
  groupHeaderRow.getCell(totalsStart).value = 'Period totals'
  columnHeaderRow.getCell(totalsStart).value = 'Collected'
  columnHeaderRow.getCell(totalsStart + 1).value = 'Owed'
  columnHeaderRow.getCell(totalsStart + 2).value = 'Total'
  worksheet.mergeCells(
    groupHeaderRowNumber,
    totalsStart,
    groupHeaderRowNumber,
    totalsStart + 2
  )

  columnHeaderRow.getCell(1).value = 'Team'
  ;[groupHeaderRow, columnHeaderRow].forEach((row) => {
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.style = { ...excelHeaderStyle }
    })
    row.commit()
  })

  const formatRow = (team) => {
    const row = { team: team.organizationName }
    months.forEach((monthKey) => {
      row[`${monthKey}_collected`] = money(team.months?.[monthKey]?.collected)
      row[`${monthKey}_owed`] = money(team.months?.[monthKey]?.owed)
    })
    row.period_collected = money(team.collected)
    row.period_owed = money(team.owed)
    row.period_total = money(team.total)
    return row
  }

  const keys = [
    'team',
    ...months.flatMap((monthKey) => [
      `${monthKey}_collected`,
      `${monthKey}_owed`,
    ]),
    'period_collected',
    'period_owed',
    'period_total',
  ]

  worksheet.columns = keys.map((key) => ({
    key,
    width: key === 'team' ? 28 : 14,
  }))

  report.teams.forEach((team) => {
    worksheet.addRow(formatRow(team))
  })

  const totalsRowValues = { team: 'Total' }
  months.forEach((monthKey) => {
    totalsRowValues[`${monthKey}_collected`] = money(
      report.totals?.months?.[monthKey]?.collected
    )
    totalsRowValues[`${monthKey}_owed`] = money(
      report.totals?.months?.[monthKey]?.owed
    )
  })
  totalsRowValues.period_collected = money(report.totals?.collected)
  totalsRowValues.period_owed = money(report.totals?.owed)
  totalsRowValues.period_total = money(report.totals?.total)
  const totalsRow = worksheet.addRow(totalsRowValues)
  styleTotalRow(totalsRow, worksheet, false)

  keys.forEach((_, index) => {
    if (index === 0) return
    currencyFormat(index + 1, worksheet, headerRows)
  })

  return saveWorkbook(workbook, 'accounting report')
}

export const monthLabelForTests = monthLabel
